import { IMAGES_CHANGED, IMAGES_CLEAR_STATE, IMAGES_LOADING, IMAGES_LAST_USED_ATTACHMENT } from '../actions/filesActions';

export const initialState = {
  images: [],
  isLoading: true,
  lastUsedAttachment: null
}

export default function filesWidgetReducer(state = initialState, action) {
  switch (action.type) {
    case IMAGES_LOADING:
      return {
        ...state,
        isLoading: action.payload
      }
    case IMAGES_CHANGED:
      return {
        ...state,
        images: action.payload
      };
    case IMAGES_CLEAR_STATE:
      return {
        ...state,
        ...initialState
      };
    case IMAGES_LAST_USED_ATTACHMENT:
      return {
        ...state,
        lastUsedAttachment: action.payload
      }
    default:
      return state;
  }
}
